import i18n from 'modules/core/lib/i18n'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

export type PerformanceV2FeaturesAvailability = {
  hasReviewProcess?: boolean
  hasGoalsV2?: boolean
  hasOneOnOnes?: boolean
  hasFeedbacks?: boolean
  hasCycles?: boolean
  hasCompetencies?: boolean
  hasAnalytics?: boolean
  hasCopilotReview?: boolean
}

export const getModuleActiveFeatures = (
  featureAvailability: PerformanceV2FeaturesAvailability,
  navigation: Navigation<NavigationPaths>
) => {
  const features = [
    {
      name: i18n.t('performance_process.reviews.reviews'),
      path: navigation.performanceProcess.reviews.fullPath(),
      isVisible: featureAvailability.hasReviewProcess,
    },
    {
      name: i18n.t('performance_goals.sidebar.title'),
      path: navigation.performanceGoals.fullPath(),
      isVisible: featureAvailability.hasGoalsV2,
    },
    {
      name: i18n.t('sidebar.one_on_ones'),
      path: navigation.performanceOneOnOnes.fullPath(),
      isVisible: featureAvailability.hasOneOnOnes,
      keywords: [i18n.t('one_on_ones.keywords.one_on_ones')],
    },
    {
      name: i18n.t('performance_feedbacks.pages.feedbacks_index.title'),
      path: navigation.performanceFeedbacks.fullPath(),
      isVisible: featureAvailability.hasFeedbacks,
    },
    {
      name: i18n.t('performance_cycles.title'),
      path: navigation.performanceCycles.fullPath(),
      isVisible: featureAvailability.hasCycles,
    },
    {
      path: navigation.competencies.fullPath(),
      name: i18n.t('competencies_v3.sidebar.title'),
      isVisible: featureAvailability.hasCompetencies,
    },
    {
      name: 'Copilot Review',
      path: navigation.performanceProcess.reviews.copilot.fullPath(),
      isVisible: featureAvailability.hasCopilotReview,
    },
  ]

  const [index, ...others] = features.filter(({ isVisible }) => isVisible)
  const activeFeatures = index ? [{ ...index, index: true }, ...others] : []

  return {
    index,
    activeFeatures,
    features,
  }
}
